import Vue from "vue"
import VueI18n from "vue-i18n"
import Cookies from "js-cookie"
import { merge } from "lodash"
import { getLang, getTenantDir, getTenantId } from "@/plugins/env"
import commonEN from "@/assets/lang/en"
import commonZH from "@/assets/lang/zh"
const tenantDir = getTenantDir()
const getAdditionalEN = () => import(`@/assets/lang/${tenantDir}/en`)
const getAdditionalZH = () => import(`@/assets/lang/${tenantDir}/zh`)
if (!Vue.__use_i18n__) {
  Vue.__use_i18n__ = true
  Vue.use(VueI18n)
}

export function getLanguage() {
  return getLang()
}

let i18n

async function initI18n(app) {
  const additionalEN = await getAdditionalEN()
  const additionalZH = await getAdditionalZH()
  const en = merge(commonEN, additionalEN)
  const zh = merge(commonZH, additionalZH)
  i18n = new VueI18n({
    locale: getLang(),
    messages: {
      en_US: en,
      zh_HK: zh
    },
    // 去除警告
    silentTranslationWarn: true
  })
}

export const translate = function (key, params) {
  return (i18n && i18n.t(key, params)) || key
}

export default async ({ app }) => {
  await initI18n(app)
  app.i18n = i18n
}
